import { render, staticRenderFns } from "./MedicalContentTemplateEditPopup.vue?vue&type=template&id=d4932822&scoped=true&"
import script from "./MedicalContentTemplateEditPopup.vue?vue&type=script&lang=js&"
export * from "./MedicalContentTemplateEditPopup.vue?vue&type=script&lang=js&"
import style0 from "./MedicalContentTemplateEditPopup.vue?vue&type=style&index=0&id=d4932822&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4932822",
  null
  
)

export default component.exports